module.exports = __webpack_public_path__ + "static/media/icono_campana_salida.84a21446.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/CallWindow/icono_campana_salida.svg
// module id = 1756
// module chunks = 0